<template>
    <el-table
        :data="tableDatas"
        style="width: 100%"
        :cell-style="{
            'font-size': '16px',
            color: '#333',
        }"
        :header-cell-style="{
            'background-color': '#d7d7d7',
            'font-weight': '700',
            color: '#333',
            'font-size': '16px',
        }"
    >
        <el-table-column label="序号" align="center" header-align="center">
            <template slot-scope="scope">
                <div>
                    {{ scope.row.rowNum }}
                </div>
            </template>
        </el-table-column>
        <el-table-column
            label="课程名称"
            prop="courseName"
            align="center"
            header-align="center"
        >
            <template slot-scope="scope">
                <div
                    style="cursor: pointer;color:#409EFF"
                    @click="linkToCourse(scope.row.courseId,scope.row)"
                >
                    {{ scope.row.courseName }}
                </div>
            </template>
        </el-table-column>
        <el-table-column
            label="课程代码"
            prop="courseCode"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="考试方式"
            prop="examinationType"
            align="center"
            header-align="center"
        >
          <template slot-scope="scope">
            {{dictList.find(v=>v.value===scope.row.examinationType)?dictList.find(v=>v.value===scope.row.examinationType).label:''}}
          </template>
        </el-table-column>
        <el-table-column
            label="课程学分"
            prop="coursePoint"
            align="center"
            header-align="center"
            v-if='type === "baseCourse"'
        >
        </el-table-column>
        <el-table-column
            label="学习中(批次)"
            prop="learningCount"
            align="center"
            header-align="center"
            v-if='type === "baseCourse"'
        ></el-table-column>
        <el-table-column
            label="考试类别"
            prop="videoType"
            align="center"
            header-align="center"
            v-if='type !== "baseCourse"'
        >
          <template slot-scope="scope">
            {{videoTypeList&&videoTypeList.find(v=>v.id===Number(scope.row.videoType))?videoTypeList.find(v=>v.id===Number(scope.row.videoType)).videoTypeTitle:''}}
          </template>
        </el-table-column>
        <el-table-column
            label="课程属性"
            prop="courseNature"
            align="center"
            header-align="center"
            v-if='type !== "baseCourse"'
        >
          <template slot-scope="scope">
            {{courseAttributeList.find(v=>v.id===scope.row.courseAttribute)?courseAttributeList.find(v=>v.id===scope.row.courseAttribute).label:''}}
          </template>
        </el-table-column>
        <el-table-column
            label="建课学校"
            prop="schoolName"
            align="center"
            header-align="center"
            v-if='type !== "baseCourse"'
        ></el-table-column>
        <el-table-column
            label="建课老师"
            prop="teacherName"
            align="center"
            header-align="center"
            v-if='type !== "baseCourse"'
        ></el-table-column>
        <el-table-column
            :label="type === 'baseCourse'?'开课批次数':'开课批次/班级'"
            prop="batch"
            align="center"
            header-align="center"
            v-if='type !== "baseCourse"'
        ></el-table-column>
        <el-table-column
            label="报名中(批次)"
            prop="signCount"
            align="center"
            header-align="center"
             v-if='type !== "totalCourse"'
        ></el-table-column>
        <el-table-column
            label="学习中(批次)"
            prop="learningCount"
            align="center"
            header-align="center"
             v-if='type !== "totalCourse"'
        ></el-table-column>
        <el-table-column
            label="未开课(批次)"
            prop="noLearnCount"
            align="center"
            header-align="center"
            v-if='type !== "totalCourse"'
        ></el-table-column>
        <el-table-column
            label="已结课(批次)"
            prop="closeCount"
            align="center"
            header-align="center"
            v-if='type !== "totalCourse"'
        ></el-table-column>
        <el-table-column
            label="课程总数"
            prop="courseCount"
            align="center"
            header-align="center"
            v-if='type === "baseCourse"'
        ></el-table-column>
        <el-table-column
            label="学习中人数"
            prop="stuLearnNum"
            align="center"
            header-align="center"
            v-if='type !== "totalCourse"'
        ></el-table-column>
        <el-table-column
            label="学习总人数"
            prop="stuTotalNum"
            align="center"
            header-align="center"
             v-if='type !== "totalCourse"'
        ></el-table-column>
        <el-table-column
            label="班级名称"
            prop="albumTitle"
            align="center"
            header-align="center"
             v-if='type === "totalCourse"'
        ></el-table-column>
        <el-table-column
            label="状态"
            prop="status"
            align="center"
            header-align="center"
            v-if='type === "totalCourse"'
        ></el-table-column>
        <el-table-column
            label="开课机构"
            prop="rkMhmName"
            align="center"
            header-align="center"
            v-if='type === "totalCourse"'
        ></el-table-column>
        <el-table-column
            label="任课老师"
            prop="rkTeacherName"
            align="center"
            header-align="center"
            v-if='type === "totalCourse"'
        ></el-table-column>
        <el-table-column
            label="学习人数"
            prop="stuTotalNum"
            align="center"
            header-align="center"
            v-if='type === "totalCourse"'
        ></el-table-column>
        <el-table-column
            label="平均分"
            prop="averageScore"
            align="center"
            width="70"
            header-align="center"
             v-if='type === "totalCourse"'
        >
          <template slot-scope="scope">
            {{scope.row.isShow?scope.row.averageScore:'点击 "查看"'}}
          </template>
        </el-table-column>
         <el-table-column
            label="合格 占比"
            prop="passRatio"
            align="center"
            width="70"
            header-align="center"
            v-if='type === "totalCourse"'
        >
          <template slot-scope="scope">
            {{scope.row.isShow?scope.row.passRatio+'%':'点击 "查看"'}}
          </template>
        </el-table-column>
        <el-table-column
            label="良好 占比"
            prop="middleRatio"
            align="center"
            width="70"
            header-align="center"
            v-if='type === "totalCourse"'
        >
          <template slot-scope="scope">
            {{scope.row.isShow?scope.row.middleRatio+'%':'点击 "查看"'}}
          </template>
        </el-table-column>
        <el-table-column
            label="优秀 占比"
            prop="topRatio"
            align="center"
            width="70"
            header-align="center"
            v-if='type === "totalCourse"'
        >
          <template slot-scope="scope">
            {{scope.row.isShow?scope.row.topRatio+'%':'点击 "查看"'}}
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            prop="stuTotalNum"
            align="center"
            header-align="center"
             v-if='type === "totalCourse"'
        >
          <template slot-scope="scope">
            <el-button type="text" @click="handleCheck(scope.row)">查看</el-button>
          </template>
        </el-table-column>
    </el-table>
</template>

<script>
import {getRatioByBatchId} from '@/api/TeachingStatistics'
import {getVideoType,getBaseDictType} from '@/api/TeacherClassroomManagement/MyClassroomTution'
export default {
    props: ["tableData",'type'],
    data() {
      return {
        videoTypeList: [], // 考试类别
        dictList:[
          {value:'1',label:'笔试'},
          {value:'2',label:'实践考核'}
        ], // 考试方式
        courseAttributeList:[
          {id:'1',label:'考核'},
          {id:'2',label:'培训'},
        ], // 课程属性
        tableDatas: this.tableData
      };
    },
    created(){
      this.getVideoTypes();
      // this.getBaseDictTypes();
    },
    methods: {
      linkToCourse(courseId,row) {
        this.$emit("linkToCourse", courseId,row);
      },
      /** 获取考试类别 */
      async getVideoTypes() {
        let {data} = await getVideoType()
        if(data.code===100000){
          this.videoTypeList = data.data;
        }
      },
      /** 获取考试方式 */
      async getBaseDictTypes(){
        let {data} = await getBaseDictType();
        this.dictList = data.data;
      },
      /** 查看占比 */
      async handleCheck(row){
        let newRow = JSON.parse(JSON.stringify(row));
        let {data} = await getRatioByBatchId({batchId:newRow.batchId});
        if(data.code===100000){
          newRow.passRatio = data.data.passRatio;
          newRow.middleRatio = data.data.middleRatio;
          newRow.topRatio = data.data.topRatio;
          newRow.averageScore = data.data.averageScore;
          newRow.isShow = true;
          let index = this.tableDatas.findIndex(v=>v.batchId===newRow.batchId);
          this.$set(this.tableDatas,index,newRow)
        }
      }
    },
    watch:{
      tableData:function(val){
        this.tableDatas = val;
      }
    }
};
</script>

